import ChevronLeftIcon from "@heroicons/react/24/outline/ChevronLeftIcon";
import { CUSTOMIZER_SAVE_BUTTON_TEST_ID, NODE_NAME_INPUT_TEST_ID } from "constants/test";
import Button from "pages/configurator/components/button";
import Input from "pages/configurator/components/input";
import { FunctionComponent } from "react";

interface CustomizerHeaderProps {
  onSave: () => void;
  onClose: () => void;
  name: string;
  setName: (val: string) => void;
}

const CustomizerHeader: FunctionComponent<CustomizerHeaderProps> = ({ onSave, onClose, name, setName }) => {
  return (
    <div className="flex justify-between mb-10 items-center sticky top-0 bg-white pb-2 pt-6 z-10">
      <div onClick={onClose} className="bg-gray-100 p-1.5 rounded hover:bg-gray-200 cursor-pointer">
        <ChevronLeftIcon className="w-5" />
      </div>
      <Input data-testid={NODE_NAME_INPUT_TEST_ID} value={name} onChange={(e) => setName(e.target.value)}></Input>
      <Button data-testid={CUSTOMIZER_SAVE_BUTTON_TEST_ID} onClick={onSave} className="w-[126px]" variant="primary">
        Save
      </Button>
    </div>
  );
};

export default CustomizerHeader;
